module.exports = __webpack_public_path__ + "static/media/App-Store-Badge-Coming-Soon.e8d14810.png";